import React from "react"
import { Box } from "@mui/system"
import Stepper from "@mui/material/Stepper"
import Step from "@mui/material/Step"
import StepContent from "@mui/material/StepContent"
import Button from "@mui/material/Button"
import Paper from "@mui/material/Paper"
import Typography from "@mui/material/Typography"

import { HowToDataSteps } from "./../../assets/HowToContent.js"
import { Link } from "react-router-dom"
import { StepButton } from "@mui/material"

function HowToTabComponent() {
	const [activeStep, setActiveStep] = React.useState(0)

	const handleNext = () => {
		setActiveStep((prevActiveStep) => prevActiveStep + 1)
	}

	const handleBack = () => {
		setActiveStep((prevActiveStep) => prevActiveStep - 1)
	}

	const handleReset = () => {
		setActiveStep(0)
	}

	const handleStep = (s) => () => {
		setActiveStep(s)
	}
	return (
		<Box sx={{ maxWidth: 1000 }}>
			<Stepper activeStep={activeStep} orientation="vertical" nonLinear>
				{HowToDataSteps.map((step, index) => (
					<Step key={step.label}>
						<StepButton
							optional={
								index === HowToDataSteps.length - 1 ? (
									<Typography variant="caption">Útimo paso</Typography>
								) : null
							}
							onClick={handleStep(index)}
						>
							{step.label}
						</StepButton>
						<StepContent>
							<Typography>{step.description}</Typography>
							<Box sx={{ mb: 2 }}>
								<div>
									<Button
										variant="contained"
										onClick={handleNext}
										sx={{ mt: 1, mr: 1 }}
									>
										{index === HowToDataSteps.length - 1
											? "Terminar"
											: "Continuar"}
									</Button>
									<Button
										disabled={index === 0}
										onClick={handleBack}
										sx={{ mt: 1, mr: 1 }}
									>
										Atrás
									</Button>
								</div>
							</Box>
						</StepContent>
					</Step>
				))}
			</Stepper>
			{activeStep === HowToDataSteps.length && (
				<Paper square elevation={0} sx={{ p: 3 }}>
					<Typography>Has completado todos los pasos!</Typography>
					<Typography>Si quieres saber más puedes venir a probar!</Typography>
					<Typography>
						<Link to="/contacta">Contacta</Link> con nosotros y te diremos cómo.
					</Typography>
					<Button
						variant="contained"
						onClick={handleReset}
						sx={{ mt: 1, mr: 1 }}
					>
						Reiniciar
					</Button>
				</Paper>
			)}
		</Box>
	)
}

export default HowToTabComponent
